import { render, staticRenderFns } from "./Tenancy.vue?vue&type=template&id=dc4173ca"
import script from "./Tenancy.vue?vue&type=script&lang=js"
export * from "./Tenancy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports